import { AccountSessionDto } from '@splitsecondconnect/ultramarine-shared';
import { RenterUserModel } from '../models';

/**
 * Session card shown for a signed-in renter.
 */
export function accountSessionDtoToRenterUser(
  session: AccountSessionDto,
): RenterUserModel {
  return {
    id: session.id,
    uuid: session.uuid,
    handle: session.handle,
    profileComplete: session.profileComplete,
  };
}
